import React, { memo } from 'react'
import { Path, Circle as _Circle } from 'react-native-svg'

import { IconProps } from '../IconProps'
import { IconBase } from '../IconBase'
import { themed } from '../themed'

const Icon = (props) => {
  const { color = 'black', size = 24, ...otherProps } = props
  return (
    <IconBase
      width={size}
      height={size}
      viewBox="0 0 28 28"
      fill="none"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...otherProps}
    >
      <Path
        d="M20.25 18.258c-.855 0-1.62.338-2.205.866l-8.021-4.668a3.68 3.68 0 0 0 .101-.788c0-.27-.045-.529-.101-.787l7.931-4.624a3.36 3.36 0 0 0 2.295.911 3.37 3.37 0 0 0 3.375-3.375 3.37 3.37 0 0 0-3.375-3.375 3.37 3.37 0 0 0-3.375 3.375c0 .27.045.529.101.787l-7.931 4.624a3.36 3.36 0 0 0-2.295-.911 3.37 3.37 0 0 0-3.375 3.375 3.37 3.37 0 0 0 3.375 3.375 3.36 3.36 0 0 0 2.295-.911l8.01 4.68c-.056.236-.09.483-.09.731a3.289 3.289 0 0 0 3.285 3.285 3.289 3.289 0 0 0 3.285-3.285 3.289 3.289 0 0 0-3.285-3.285Z"
        fill={`${color}`}
      />
    </IconBase>
  )
}

Icon.displayName = 'IconShare'

export const IconShare = memo<IconProps>(themed(Icon))
